
const Contact = () => {
    return (
        <div>Work on ways I can be contacted!</div>
    )
}

export default Contact;